import { styled, Box } from "@mui/material";

export const StyledToolPanel = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: 3,
  overflowX: "auto",
  containerType: "inline-size",
}));
